import { SelectDropdown } from '@common-fe/common-fe';
import styled from 'styled-components';

export const StyledSelectDropdown = styled(SelectDropdown)`
min-width: 150px;
`;
